import React from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import {styled, Theme }from "@mui/material/styles";
import {
	Typography,
	Box,
	Button,
    Grid,
    Divider,Accordion,AccordionSummary, AccordionDetails
  } from '@mui/material';
  import RectangleIcon from "@mui/icons-material/Rectangle";

  import { ExpandMore} from "@mui/icons-material";

  import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
interface GradientBoxProps {
  gradient: string;
}

const TrapezoiDGradientBoxLeft = styled(Box)<GradientBoxProps>(({ gradient }) => ({
  width: '20%',
  minHeight: '67vh',
  background: gradient,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginRight:'2vh',
  clipPath: 'polygon(100% 20%, 100% 80%, 0 100%, 0 0)', 
}));

const TrapezoiDGradientBoxRight = styled(Box)<GradientBoxProps>(({ gradient }) => ({
  width: '20%',
  minHeight: '67vh',
  background: gradient,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginLeft:'2vh',
  clipPath: 'polygon(0 80%, 0 20%, 100% 0, 100% 100%)', 
}));

const questionsAndAnswers = [
    {
        question: "What is Intellicore?",
        answer: "Intellicore provides a self-service environment for you to easily create and manage your cloud infrastructure. You can build Kubernetes clusters, deploy applications, and configure various services, all through a user-friendly interface."
    },
    {
      question: "Who can use Intellicore?",
      answer: "Intellicore is designed for developers, DevOps engineers, and IT professionals who need to deploy and manage applications in a cloud environment. Access is granted based on roles and permissions defined by your organization's administrator."
    },
    {
      question: "How easy is it to onboard a service onto the Intellicore?",
      answer:"We've designed Intellicore for simplicity. You don't need to be a cloud expert to get started. Our intuitive interface and pre-built templates guide you through the process, significantly reducing the complexity of cloud deployments. Think drag-and-drop, not command-line chaos!"
    },
    {
      question: "Do I need to have extensive knowledge of the cloud to use Intellicore?",
      answer:"We've abstracted away much of the underlying cloud complexity. While a basic understanding helps, you can deploy services without needing deep cloud expertise. We handle the infrastructure, so you can focus on your code."
    }
  ]

// const StyledBox = styled(Box)<{ isHovered: boolean; initialWidth: number }>(
//     ({ theme, isHovered, initialWidth }) => ({
//       width: isHovered ? '50%' : `${initialWidth}%`, // Dynamic width based on hover
//       minHeight: isHovered ? '50vh': "50vh",
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       transition: 'width 0.3s ease', // Smooth transition effect
//       cursor: 'pointer',
//       border:"1px solid white",
//       color:'white',
//       backgroundImage: `url('/assets/hover-background.svg')`,
//       backgroundSize: 'cover', 
//       backgroundRepeat: 'no-repeat',
//       marginInline:"1vw",
//       borderRadius:"15px",

     
//     })
//   );
interface StyledBoxProps {
  isActive: boolean;
  backgroundImage?: string;
}

// --- StyledBox Component ---
// Uses isActive prop to determine width and applies background styles
const StyledBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isActive' && prop !== 'backgroundImage', // Prevent custom props from reaching the DOM element
})<StyledBoxProps>(({ theme, isActive, backgroundImage }) => ({
  // Calculate width: 50% if active, 25% otherwise
  width: isActive ? '50%' : '25%',
  minHeight: '50vh', // Maintain vertical height
  display: 'flex',
  // Align content (text block) to the bottom
  alignItems: 'flex-end',
  justifyContent: 'flex-start', // Start content from the left
  // Smoother transition for width changes
  transition: 'width 0.4s ease-in-out',
  cursor: 'pointer',
  border: '1px solid #020202',
  color: 'white',
  // Apply background image from prop or default
  ...(isActive
    ? {
        // Styles when ACTIVE: Apply the specific or default background image
        backgroundImage: `url(${backgroundImage || '/assets/hover-background.svg'})`,
        // You might want backgroundColor to be transparent or removed if the image covers fully
        //backgroundColor: 'transparent',
      }
    : {
        // Styles when INACTIVE: No specific image, set a background color
        backgroundImage: `url(${'/assets/hover-background.svg'})`,
        // Set a suitable background color for the inactive state.
        // Example: Use a color from the theme palette or a specific hex code.
        //backgroundColor: theme.palette.mode === 'dark' ? '#171717' : '#F5F5F5', // Example theme-aware color
        // Or directly: backgroundColor: '#1C1C1C',
      }),
  // backgroundImage: `url(${backgroundImage || '/assets/hover-background.svg'})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover', // Ensures the image covers the entire box
  backgroundPosition: 'center', // Centers the image within the box
  marginInline: '1vw',
  borderRadius: '15px',
  position: 'relative', // Useful for potential absolute positioning of overlays if needed
  overflow: 'hidden', // Crucial: prevents content spillover and ensures bg covers fully
  // Basic responsiveness: On smaller screens, you might want to adjust minHeight or width distribution further via media queries if needed
  [theme.breakpoints.down('md')]: {
    minHeight: '40vh', // Slightly reduce height on medium screens and below
     // The 50/25 split might look cramped on very small screens. Consider stacking them (flexDirection: column) below 'sm' or 'md'.
  },
   [theme.breakpoints.down('sm')]: {
     // Example: Stack them on small screens
     // width: '90%', // Take full width when stacked
     // marginInline: 'auto',
     // marginBlock: '10px',
     // minHeight: '35vh',
     // For simplicity, we'll keep the row layout for now.
   },
}));

  // State to track the active box, initialized to 1 (Step 1)
  

  

  // Data for the steps - easier to manage and map
  const steps = [
    {
      index: 1,
      title: 'Fill the form',
      description: 'Simply input all infrastructure details required and wait for approval.',
      image: '/assets/Step_1.svg', // Ensure these paths are correct
    },
    {
      index: 2,
      title: 'Infra, Security and Observability checks',
      description: 'Once the code is deployed, sit back and relax a bit. Let Intellicore do the rest for you.',
      image: '/assets/Step_2.svg',
    },
    {
      index: 3,
      title: 'Final deployment',
      description: 'Get MVPs ready in no time! Start QA testing and deliver quickly.',
      image: '/assets/Step_3.svg',
    },
  ];
// const StyledBox = styled(Box)<{ isHovered: boolean; initialWidth: number; backgroundImage?: string }>(
//   ({ theme, isHovered, initialWidth, backgroundImage }) => ({
//     width: isHovered? '50%': `${initialWidth}%`,
//     minHeight: isHovered? '50vh': '50vh',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     transition: 'width 0.05s ease',
//     cursor: 'pointer',
//     border: '1px solid #020202',
//     color: 'white',
//     backgroundImage: backgroundImage? `url(${backgroundImage})`: `url('/assets/hover-background.svg')`, // Use input or default
//     backgroundRepeat: 'no-repeat',
//     backgroundSize: 'cover',
//     marginInline: '1vw',
//     borderRadius: '15px',
//   })
// );

  const LandingPage: React.FC = () =>{
    const navigate = useNavigate();
    const handleMouseEnter = (index: number) => {
      setActiveBox(index);
    };
  
    // Reset to default (Step 1 active) when mouse leaves the container
    const handleMouseLeaveContainer = () => {
      setActiveBox(1);
    };
    const [activeBox, setActiveBox] = useState<number>(1);
    const [dimensions, setDimensions] = useState({
        width: window.innerWidth * 0.7, // Initial width (50% of window)
        height: window.innerHeight * 0.66, // Initial height (30% of window)
      });
    
      useEffect(() => {
        const handleResize = () => {
          setDimensions({
            width: window.innerWidth * 0.7, // Adjust width dynamically
            height: window.innerHeight * 0.66, // Adjust height dynamically
          });
        };
    
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);




        // const [hoveredBox, setHoveredBox] = useState<number | null>(null);
      
        // const handleMouseEnter = (boxNumber: number) => {
        //   setHoveredBox(boxNumber);
        // };
      
        // const handleMouseLeave = () => {
        //   setHoveredBox(null);
        // };
    
    

    return(<Box
        sx={{
          bgcolor: '#ffffff', 
          display: 'flex',
          flexDirection: 'column',
          background:'#101010',
          justifyContent: 'center', 
        
        }}
      >
        <Box  sx={{ display: 'flex',justifyContent: 'space-between', pr:4,pl:4, py:2}}>
          {/* <img
					src="/assets/favicon-white.png"
					alt="Logo Icon"
					style={{
						position: "absolute",
						top: "23px",
						left: "25px",
						width: "44px",
						height: "44px",
					}}
				/> */}
        <Box mt={3} mb={0} component={"img"} src="/assets/intellicore-transparent-white.png" alt="Your Logo" height={"27px"}  width={"125px"}  ></Box>  
        <Box mt={3} mb={0} mr={2} sx={{display:'flex', flexDirection:'row' , alignItems:'center', justifyContent:'center'}} >
          {/* <Link to="/docs" style={{ textDecoration: 'none', fontFamily:'Gilroy-Regular',fontSize:'18px', display: 'flex', alignItems: 'center', color:"#E6E6E6", marginRight:"2vw" }}>
                                   BOOK A DEMO
                                </Link>   */}
    

          {/* <Link to="/docs" style={{ textDecoration: 'none', fontFamily:'Gilroy-Regular',fontSize:'18px', display: 'flex', alignItems: 'center', color:"#E6E6E6" , marginRight:"2vw"}}>
                                   DOCS
                                </Link>   */}
                <a
    href={`${process.env.REACT_APP_HOST_DOMAIN || 'http://localhost:3000'}/docs`} // Construct the full URL
    target="_blank" // Opens in a new tab
    rel="noopener noreferrer" // Security best practice for target="_blank"
    style={{
        textDecoration: 'none',
        fontFamily: 'Gilroy-Regular',
        fontSize: '16px',
        display: 'flex',
        alignItems: 'center',
        color: "#E6E6E6",
        marginRight: "2vw"
    }}
>
    DOCS
</a>

                <a
        href="https://forms.gle/xxeeJapZGGUnJQ9RA" // <-- REPLACE THIS WITH YOUR ACTUAL GOOGLE FORM URL
        target="_blank" // Opens the link in a new tab/window
        rel="noopener noreferrer" // Security best practice for target="_blank"
        style={{
            textDecoration: 'none',
            fontFamily: 'Gilroy-Regular',
            
            fontSize: '16px',
            display: 'flex',
            alignItems: 'center',
            color: "#E6E6E6",
         
        }}
    >
        BOOK A DEMO
    </a>

        </Box>
           
        </Box>

        <Box sx={{
        height:'auto',
        // background: '#171717',
  
        backgroundImage: `url('/assets/background_hero_fold.svg')`,
        backgroundSize:'100% 100%', 
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center', 
      
        borderRadius: '10px',
        MinHeight:"70vh",
        // margin: (theme) => theme.spacing(2),
        marginInline:"2vw",
        display: "flex",
        flexDirection: "column",
            // justifyContent: "center",
        alignItems:"center"
            
        }}>
       
       
             {/* Hero Section */}
             
          <Typography sx={{mt:"0vh", pt:"10vh" ,display:"flex", alignItem:"center", flexDirection:"column"}}>
            <Typography  fontFamily="Gilroy-Bold" fontSize="56px"  sx={{ color:"rgba(0, 100, 255, 1)", textAlign:"center"}}>Supercharge </Typography>
            <Typography fontFamily="Gilroy-Bold" fontSize="56px" sx={{color:"rgba(207, 207, 207, 1)", textAlign:"center"}}>GenAI Development with a Unified Platform</Typography>
          </Typography>

          {/* <Typography maxWidth="70vw" sx={{color:"rgba(207, 207, 207, 1)",fontSize:"20px", mt:"2vh", justifyContent:'center', alignItems:'center'}}>
          <Typography  fontFamily="Gilroy-Bold" fontSize="25px" component="span" sx={{ color:"rgba(0, 100, 255, 1)", textAlign:"center"}}>Futurify with us</Typography> leveraging  
          <Typography  fontFamily="Gilroy-Bold" fontSize="25px" component="span" sx={{ color:"rgba(0, 100, 255, 1)", textAlign:"center"}}>AI-driven </Typography>
          insights,  <Typography  fontFamily="Gilroy-Bold" fontSize="25px" component="span" sx={{ color:"rgba(0, 100, 255, 1)", textAlign:"center"}}>Data-powered </Typography>
          decisions, and  
          <Typography  fontFamily="Gilroy-Bold" fontSize="25px" component="span" sx={{ color:"rgba(0, 100, 255, 1)", textAlign:"center"}}>Multi ☁️ Cloud </Typography>
           scalability with seamless synergy in a single, powerful platform.
          </Typography> */}

          {/* <Typography maxWidth="30vw" sx={{color:"rgba(207, 207, 207, 1)",fontSize:"20px",display:"flex", alignItem:"center", flexDirection:"column", mt:"2vh"}}>
            Empowering developer productivity, Enhancing operational efficiency, Ensuring compliance.
          </Typography> */}


           <Typography maxWidth="70vw" sx={{color:"rgba(207, 207, 207, 1)",fontSize:"20px",display:"flex", textAlign:'center' , mt:"2vh"}}>
           Futurify with us by leveraging AI-driven insights, data-powered decisions, and multi ☁️ cloud scalability — all in one seamless, powerful platform.
          </Typography>
  
          <Box sx={{ display:'flex', alignItems:'center', flexDirection:"column",mt: 3 }}>
            <Button
                variant="contained"
                color="primary"
                sx={{
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    color: "black",
                    padding: "1.5vh 5vw",
                    fontSize: "0.875rem",
                    textTransform: "none",
                }}
                onClick={() => navigate("/login")}
            >
                <Typography fontSize="16px" fontFamily="Gilroy-Bold">
                    Get Started
                </Typography>
            </Button>
            <Typography sx={{display:'flex', alignItems:'center',  mt:"1vh"}} >
            <Box component={"img"} src="/assets/google_icon.svg" alt="alt" sx={{mx:"0.25vw"}} ></Box> <Typography fontSize="12px" fontFamily="Gilroy-Medium" color="rgba(255, 255, 255, 1)">Login with Google</Typography>
            </Typography>
          </Box>
          <Box px="10vw">
  {/* <Box
    sx={{
      mt: "10vh",
      height: '67vh',
      width: '70vw',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'black',
      borderTopLeftRadius: '20px',
      borderTopRightRadius: '20px',
      paddingTop: "35px",
      paddingX: "20px",
    }}
  > */}

    <Box
      sx={{
        width: "80vw",
        height: "80vh",
        // width: dimensions.width,
        // height: dimensions.height,
        //border: "2px solid gray",
        borderTopLeftRadius: '20px',
        borderTopRightRadius: '20px',
        marginTop:"4vh",
        overflow: "hidden", // Keeps the stretched image contained
        // Flex alignment centers the img *element* but fill makes the *content* take all space
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        //backgroundColor: "#fff", // Background visible if image has transparency
      }}
    >
      <img
        src="/assets/landing-page-ss.svg"
        alt="Resizable"
        style={{
          width: "100%",      // Essential for fill: makes the image element try to be 100%
          height: "100%",     // Essential for fill: makes the image element try to be 100%
          objectFit: "fill",  // <--- CHANGE HERE: Stretches/squashes image to fill container
          display: 'block', // Often good practice for images to avoid extra space below
        }}
      />
    {/* </Box> */}
  </Box>
</Box>
         {/* <Box px="10vw">
          <Box
      sx={{
        mt:"10vh",
        height: '67vh',
        width: '70vw', 
        display: 'flex',            
        justifyContent: 'center',  
        alignItems: 'center',      
        backgroundColor: 'black', 
        borderTopLeftRadius: '30px',
        borderTopRightRadius: '30px',
        paddingTop: "35px",
        paddingX:"20px", 
      }}
    >
        
         <Box
                sx={{
                  width: dimensions.width,
                  height: dimensions.height,
                  border: "2px solid gray",
                  overflow: "hidden",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#fff",
                }}
              >
                <img
                  src="/assets/portal-image-3.svg"
                  alt="Resizable"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    width:"auto",
                    height:"auto",
                    objectFit: "contain",
                  }}
                />
              </Box>
    </Box>
  
        </Box> */}
        </Box>

        {/* <Box mx={6} mb={"10vh"} sx={{display:'flex', alignItems:"center",justifyContent:"center", flexDirection:"column", mt:"3vh"}}>
                  <Typography fontFamily="Gilroy-SemiBold" fontSize="18px" color="#666666">Trusted by the leading businesses</Typography>
                  <Box sx={{display:'flex', alignItems:"center",justifyContent:"center", flexDirection:"row", mt:"2vh", flexWrap:'wrap' }}>
                        <Box component={"img"} src="/assets/logo-dell.svg" alt="Your Logo" height={"3vh"} mx={2} my={1}></Box>
                        <Box component={"img"} src="/assets/logo-zendesk.svg" alt="Your Logo" height={"3vh"} mx={2} my={1}></Box>    
                        <Box component={"img"} src="/assets/logo-rakuten.svg" alt="Your Logo" height={"3vh"} mx={2} my={1}></Box> 
                        <Box component={"img"} src="/assets/logo-pacific-funds.svg" alt="Your Logo" height={"3vh"} mx={2} my={1}></Box> 
                        <Box component={"img"} src="/assets/logo-ncr.svg" alt="Your Logo" height={"3vh"} mx={2} my={1}></Box> 
                        <Box component={"img"} src="/assets/logo-lattice.svg" alt="Your Logo" height={"3vh"} mx={2} my={1}></Box> 
                  </Box>
        </Box> */}

        
        <Box mx={6} mt={"10vh"} mb={'3vh'}>
        <Box mx={2} sx={{ display: 'flex',flexDirection: 'columm', }}>
            <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'start',   // Center items horizontally
                    color: '#3685FF',       
                    fontFamily: 'sans-serif',
                  }}
                >
                  <Box
                    sx={{
                      width: '1.5rem',   // Adjust to reduce the width
                      height: '0.2rem',  // Adjust to increase the length (height of the rectangle)
                      backgroundColor: '#3685FF', 
                      mb: 0.2          
                    }}
                  />
                  <Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                    BENEFITS
                  </Typography>
                </Box>
        </Box>
        </Box>

        <Box mx={6} mb={3} sx={{display:'flex', justifyContent:'space-between', flexDirection:'row', alignItems:'center'}}>
            <Box mx={2}>
                {/* <Typography fontFamily="Gilroy-Bold" fontSize="36px" color="#CFCFCF">
                    <Typography fontFamily="Gilroy-Bold" fontSize="36px" color="#0064FF" component="span">
                    Revolutionizing development: 
                    </Typography>
                    AI-powered intelligence, data-driven insights, cloud-scale agility.
                </Typography> */}
                <Typography fontFamily="Gilroy-Bold" fontSize="36px" color="#CFCFCF">
                    <Typography fontFamily="Gilroy-Bold" fontSize="36px" color="#0064FF" component="span">
                    Ignite development 
                    </Typography>
                    with AI's intelligence, data-driven precision, and limitless cloud agility.
                </Typography>

    
            </Box>
            <Box mx={2}>
                    <Typography fontFamily="Gilroy-Bold" fontSize="18px" color="#CFCFCF">Fortify your multi-cloud strategy with Intellicore, the essential internal developer platform (IDP) that empowers AI, Data, and Cloud teams across GCP, AWS, and Azure.</Typography>

                    {/* <Typography fontFamily="Gilroy-Bold" fontSize="18px" color="#CFCFCF">Empower AI, Data, and Cloud teams with Faraday, your unified multi-cloud IDP for GCP, AWS, and Azure.</Typography> */}
                  
            </Box>
        </Box>


        <Box mx={6} mb={3} sx={{display:'flex', alignItems:'center',flexDirection:'row' , pt:"5vh", borderTopLeftRadius:"30px", borderTopRightRadius:'30px', borderBottomLeftRadius:"30px" , width: 'auto',  
        height: '100%',
        minHeight:'50vh', 
        backgroundImage: 'url("/assets/main_pointer(1).svg")',
        backgroundRepeat: 'no-repeat', 
        backgroundPosition: 'center-top', 
        backgroundSize: 'cover', overflow:"visible",boxSizing: 'border-box' }}>
           
            <Box mx={2} sx={{display:'flex',flexDirection:'column',width:"50%", height:"100%"}}>
                <Typography ml={2} fontFamily="Gilroy-Medium" fontSize="54px" color="#CFCFCF">DevOps Culture, Automated Infrastructure</Typography>
                <Typography ml={2} fontFamily="Gilroy-Regular" fontSize="18px" color="#CFCFCF">Empowering developer productivity and  data-optimized efficiency. Ensuring compliance.</Typography>
            </Box>
            

           





        </Box>

        <Box mx={6} mb={3}sx={{display:'flex', alignItems:'center', mt:"2vh"}}>
        <Grid container spacing={2}> {/* Add spacing if you want gaps */}
      <Grid item xs={12} md={6}> 
        <Box sx={{ backgroundColor: '#171717', display: 'flex', justifyContent:'center', alignItems: 'flex-start', flexDirection:'column' ,borderRadius:"30px", height:"maxheight", minHeight:'47vh'}}>
        <Box mb={3} sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', overflow:'hidden'}} maxHeight={'20vh'}><img
                        src="/assets/1_pointer(2).svg"
                        alt="Resizable"
                        style={{
                        width: "100%",
                        height: "auto", 
                        objectFit: "contain", 
                        display: "block",
                        
                        }}
                    />
            </Box> 
          <Typography mx={4} fontFamily="Gilroy-Medium" fontSize="26px" color="rgba(207, 207, 207, 1);">Revolutionize Prototyping</Typography>
          <Typography mx={4} fontFamily="Gilroy-Regular" fontSize="18px" color='rgba(191, 191, 191, 1);'>Commit the code and get the MVP ready for test. Rest Intellicore will take care of.</Typography>
        </Box>
      </Grid>
      <Grid item xs={12} md={3}> 
        <Box sx={{ backgroundColor: '#171717', display: 'flex', justifyContent: 'center', alignItems: 'center',flexDirection:'column' ,borderRadius:"30px", height:'maxheight', minHeight:'47vh'}}>
        <Box mb={3} sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',  overflow:'hidden'}} maxHeight={'20vh'}><img
                        src="/assets/2_pointer(1).svg"
                        alt="Resizable"
                        style={{
                        width: "100%",
                        height: "auto", 
                        objectFit: "contain", 
                        display: "block",
                        }}
                    /></Box>
        <Typography mx={4} fontFamily="Gilroy-Medium" fontSize="26px" color="rgba(207, 207, 207, 1);">Improve Collaboration</Typography>
        <Typography mx={4} fontFamily="Gilroy-Regular" fontSize="18px" color='rgba(191, 191, 191, 1);'>Reduces information silos, fosters shared understanding.</Typography>
        </Box>
        
      </Grid>
      <Grid item xs={12} md={3}>
        <Box sx={{ backgroundColor: '#171717', display: 'flex', justifyContent: 'center', alignItems: 'center',flexDirection:'column' ,borderRadius:"30px", height:'maxheight', minHeight:'47vh'}}>
        <Box mb={3} sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',  overflow:'hidden'}} maxHeight={'20vh'}><img
                        src="/assets/3_pointer.svg"
                        alt="Resizable"
                        style={{
                        width: "100%",
                        height: "auto", 
                        objectFit: "contain", 
                        display: "block",
                        }}
                    /></Box>
        <Typography mx={4} fontFamily="Gilroy-Medium" fontSize="26px" color="rgba(207, 207, 207, 1);">Workflow Optimization</Typography>
        <Typography mx={4} fontFamily="Gilroy-Regular" fontSize="18px" color='rgba(191, 191, 191, 1);'>Workflow standardization by eliminating chaos and unlocks developer velocity.</Typography>
        </Box>
      </Grid>
    </Grid>
        </Box>

        <Box mx={6} mb={10} sx={{display:'flex', alignItems:'center', mt:"2vh"}}>
        <Grid container spacing={2}> 
      <Grid item xs={12} md={9}> 
        <Box sx={{ backgroundColor: '#171717', display: 'flex', justifyContent:'start', alignItems: 'left', flexDirection:'column' ,borderRadius:"30px", minHeight:"35vh"}}>
        
          <Typography my={3} mx={4} fontFamily="Gilroy-Medium" fontSize="26px" color="rgba(207, 207, 207, 1);">Eliminates Conventional Cloud Challenges</Typography>
          <Typography mb={2} mx={4} fontFamily="Gilroy-Regular" fontSize="18px" color='rgba(191, 191, 191, 1);'>You don’t have to worry about these things anymore.</Typography>
                   <Box mx={4} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start', backgroundImage: '#060606' }}>
    
    <Grid container spacing={2}>
    
      {[
        ["Lack of standardization",
        "Negative cyber events"],
        ["Time to first commit",
        "Cognitive load on dev"],
        ["Skill gap",
        "Cost"],
      ].map((text, index) => (
        <Grid item xs={12} md={4}>
        <Typography
          key={index}
          mr={6}
          fontFamily="Gilroy-Regular"
          fontSize="14px"
          color='rgba(207, 207, 207, 1);'
          // color="#0051CB"
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection:'column',
            marginBottom: '10px', // Add margin between rows
          }}
        >
          <Box mb={1.5} sx={{display:'flex' }}>
          <img
            src="/assets/close-circle-fill-blue.svg"
            alt="Cross Icon"
            style={{ width: "20px", marginRight: "1vh" , color:"#0051CB"}}
          />
          {text[0]}</Box>
          <Box mt={1.5} sx={{display:'flex'}}>
          <img
            src="/assets/close-circle-fill-blue.svg"
            alt="Cross Icon"
            style={{ width: "20px", marginRight: "1vh" }}
          />
          {text[1]}</Box>
        </Typography>
        </Grid>
      ))}

</Grid>
    </Box>
        </Box>
        
      </Grid>
      <Grid item xs={12} md={3}> 
        <Box sx={{ backgroundColor: '#171717', height: '200px', display: 'flex', justifyContent: 'center', alignItems: 'center' ,flexDirection:'column',borderRadius:"30px", backgroundImage:'linear-gradient(rgba(0, 100, 255, 1),rgba(0, 100, 255, 1))',  minHeight:"35vh"}}>
        <Box mx={4} sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',flexDirection:'column'}}>
        <Button onClick={() => navigate("/login")}>
            <img
                        src="/assets/login-arrow.svg"
                        alt="Login Icon"
                        style={{ width: "8vw", marginRight: "1vh" }}
                      />
            
        </Button>
        <Typography color='rgba(207, 207, 207, 1);'>
           get started & unlock the full potential & enhance your workflow.
        </Typography>
        </Box>
        </Box>
      </Grid>
    </Grid>
    </Box>

      
   {/* <Box sx={{ backgroundImage: `url('/assets/background_how_it_works_PNG.png')`,}}> */}
    <Box mx={6} mt={"10vh"} mb={'5vh'} >
    <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',   // Center items horizontally
                    color: '#3685FF',       
                    
                  backgroundImage: `url('/assets/background_how_it_works.svg')`,
                    // backgroundColor:"linear-gradient(180deg, #171717 , #171717)",
                    
                  }}
                >
                  <Box
                    sx={{
                      width: '1.5rem',   // Adjust to reduce the width
                      height: '0.2rem',  // Adjust to increase the length (height of the rectangle)
                      backgroundColor: '#3685FF', 
                      
                      mb: 0.4         
                    }}
                  />
                  <Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                    HOW IT WORKS
                  </Typography>

                  <Typography>
                     
                  </Typography>

                  <Typography fontFamily="Gilroy-Bold" fontSize="36px" color="#0064FF">
                  Quick & easy 
                    <Typography fontFamily="Gilroy-Bold" fontSize="36px" color="#CFCFCF" component="span">
                    process
                    </Typography>
                </Typography>
                <Typography fontFamily="Gilroy-Bold" fontSize="18px" color="#CFCFCF">Your code, your cloud, your control !!</Typography>
                {/* <Typography fontFamily="Gilroy-Bold" fontSize="18px" color="#CFCFCF">To begin using the Faraday portal</Typography> */}
                </Box>
    </Box>



   


    <Box
        mx={6} // Consider using theme spacing theme.spacing(6) for consistency
        mt={"10vh"}
        mb={'3vh'}
        sx={{
          display: 'flex',
          alignItems: 'stretch', // Make boxes stretch to the same height if content differs slightly
          justifyContent: 'center',
          // Add responsiveness for flex direction if needed
          flexDirection: { xs: 'column', md: 'row' }, // Stack on extra-small/small, row on medium and up
          gap: { xs: 2, md: 0 } // Add gap when stacked
        }}
        // Attach mouse leave listener to the container
        onMouseLeave={handleMouseLeaveContainer}
      >
        {steps.map((step) => (
          <StyledBox
            key={step.index}
            // Pass isActive based on component state and step index
            isActive={activeBox === step.index}
            // Pass the correct background image for this step
            backgroundImage={step.image}
            // Update active box on mouse enter
            onMouseEnter={() => handleMouseEnter(step.index)}
            // Apply stacking styles if needed based on breakpoint
            sx={(theme)=>({
               [theme.breakpoints.down('md')]: {
                 width: '90%', // Take more width when stacked
                 marginInline: 'auto', // Center when stacked
                 // The isActive prop will still determine the visual state if needed,
                 // but the 50/25 split is overridden here for stacked layout.
                 // If hover effect isn't desired on mobile, adjust logic/styles further.
               }
            })}
          >
            {/* Content wrapper Box */}
            <Box
              sx={{
                width: '100%', // Take full width of the StyledBox
                p: { xs: 2, md: 3 }, // Adjust padding for different screen sizes
                mb: 1,
                boxSizing: 'border-box', // Include padding in width calculation
                // Optional: Add a subtle overlay for text readability on complex backgrounds
                // backgroundColor: 'rgba(0, 0, 0, 0.3)',
                // borderBottomLeftRadius: '14px', // Match parent border radius
                // borderBottomRightRadius: '14px',
              }}
            >
              <Typography fontFamily="Gilroy-Regular" fontSize={{ xs: '12px', md: '14px' }} color="#808080">
                Step {step.index}
              </Typography>
              <Typography fontFamily="Gilroy-Bold" fontSize={{ xs: '20px', md: '24px' }} color="#CFCFCF">
                {step.title}
              </Typography>
              {/* Conditionally render the description only if the box is active */}
              {activeBox === step.index && (
                <Typography
                  fontFamily="Gilroy-Regular"
                  fontSize={{ xs: '16px', md: '18px' }}
                  color="#BFBFBF"
                  sx={{ mt: 1 }}
                >
                  {step.description}
                </Typography>
              )}
            </Box>
          </StyledBox>
        ))}
      </Box>

      
<Box sx={{backgroundImage:`url('assets/background_faqs.png')`}}>
    <Box mx={6} mt={"10vh"} mb={'3vh'} >
    <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',   // Center items horizontally
                    color: '#3685FF',       
                
                    
                  }}
                >
                  <Box
                    sx={{
                      width: '1.5rem',   // Adjust to reduce the width
                      height: '0.2rem',  // Adjust to increase the length (height of the rectangle)
                      backgroundColor: '#3685FF', 
                      mb: 0.4         
                    }}
                  />
                  <Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                    FREQUENTLY ASKED QUESTIONS
                  </Typography>

                  <Typography>
                     
                  </Typography>

                  <Typography fontFamily="Gilroy-Bold" fontSize="36px" color="#0064FF">
                  Have Questions 
                </Typography><Typography fontFamily="Gilroy-Bold" fontSize="36px" color="#CFCFCF" component="span">
                    We're here to help you
                    </Typography>
                    <Box mt={2} sx={{width:'50vw'}}>
                    {questionsAndAnswers.map((item:any,index:any) =>
													(
														<Box key={index} mb={0}>
															{/* <Typography variant="h6" color="primary" onClick={() => setAnsVisibility(qt)}>{item.question}</Typography>
															{ansVisibility? <Typography variant="body1">{item.answer}</Typography>: null} */}

											<Accordion
                      square={true}
												elevation={0}
												sx={{
													borderRadius: '16px',
                          color:'#CFCFCF',
													mt:"2vh",
                          mb:"2vh",
													"&:before": {
														mb: "2px",
														display: "none",
													},
                          "&:after": {
														mb: "2px",
														display: "none",
													},
													bgcolor: "#171717",
													
													"& .MuiAccordionSummary-root": { 
														padding: "2vh 2vh", 
													},
													"& .MuiAccordionDetails-root": { 
														padding: "0vh 2vh 2vh", 
													},
                    
												}}
											 >
												<AccordionSummary sx={{py:0,mt:2, color:'#CFCFCF'}} expandIcon={<ExpandMore sx={{color:"#CFCFCF"}}/>}>
												<Typography fontFamily="Gilroy-Bold" fontSize="20px" color="#CFCFCF" >{item.question}</Typography>
												</AccordionSummary>
												<AccordionDetails >
													
													<Typography fontFamily="Gilroy-Medium" fontSize="16px" color="#BFBFBF">{item.answer}</Typography>
												</AccordionDetails>
												
											</Accordion>
														</Box>
													)
													)}
                          </Box>
                </Box>
    </Box>
    </Box>




    <Box mx={6} mt={"10vh"} mb={'3vh'} sx={{display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'row'}}>
    <TrapezoiDGradientBoxLeft gradient="linear-gradient(to right, rgba(0, 100, 255, 0) 46.34%, rgba(0, 100, 255, 0.3) 100%)" />
    {/* <TrapezoiDGradientBoxLeft gradient="linear-gradient(to right,#6DA6FF, #0051CB)" /> */}
    <Box  px={4} sx={{display:'flex', alignItems:'flex-start',flexDirection:'column' , py:"3vh", width: '60vw',  
        height: '100%',
        minHeight:'40vh', 
        backgroundImage: 'url("/assets/footer.svg")',
        backgroundRepeat: 'no-repeat', 
        backgroundPosition: 'center', 
        backgroundSize: 'cover', overflow:"visible",boxSizing: 'border-box' }}>
        <Typography mb={1} fontFamily="Gilroy-Bold" fontSize="40px" color="#FFFFFF" maxWidth={"50%"}>Launch your MVP into the cloud and ignite innovation</Typography>
        <Typography mb={1} fontFamily="Gilroy-Regular" fontSize="18px" color="#FFFFFF" maxWidth={"50%"}>Login with your Google account and start developing without any hassle.</Typography>
        <Button
                variant="contained"
                color="primary"
                sx={{
                    backgroundColor: "black",
                    color: "white",
                    padding: "1.5vh 5vw",
                    fontSize: "0.875rem",
                    textTransform: "none",
                }}
                onClick={() => navigate("/login")}
            >
                <Typography fontSize="16px" fontFamily="Gilroy-Bold">
                    Get Started
                </Typography>
            </Button>
        </Box>
        <TrapezoiDGradientBoxRight gradient="linear-gradient(to left, rgba(0, 100, 255, 0) 46.34%, rgba(0, 100, 255, 0.3) 100%)" />
        {/* <TrapezoiDGradientBoxRight gradient="linear-gradient(to left,#6DA6FF, #0051CB)" /> */}
    </Box>


   
    
    <Divider sx={{ backgroundColor: '#FEFEF0', my: 3 }} />
    <Box mx={8}  sx={{display:'flex', alignItems:'center', justifyContent:'space-between', flexDirection:'row'}}>
    {/* <Box component={"img"} src="/assets/faraday-logo-full.svg" alt="Your Logo" height={"60px"} width={"150px"} ></Box>    */}
    <Box mt={0} mb={2} ml={-4} component={"img"} src="/assets/intellicore-transparent-white.png" alt="Your Logo" height={"35px"}  width={"160px"}  ></Box>
    <Box sx={{display:"flex", alignItems:'bottom', justifyContent:'center', flexDirection:'row'}}>  
         
              <Typography fontSize="14px" color="#FFFFFF">
              © 2025, All rights with Searce
              </Typography>
            </Box>

    </Box>
      </Box>);
  };
  export default LandingPage;